interface Props {
    title?: string
    fontSize?: 'Normal' | 'Large'
    description?: string
    alignment: 'center' | 'left'
    colorReverse?: boolean
}

function Header(props: Props) {
    return (
        <>
            {props.title || props.description
                ? (
                    <div
                        className={`flex flex-col gap-2 ${
                            props.alignment === 'left' ? 'text-left' : 'text-center'
                        }`}
                    >
                        {props.title && (
                            <h1
                                className={`text-2xl leading-8 lg:leading-10
                  ${props.colorReverse ? 'text-primary-content' : 'text-base-content'}
                  ${props.fontSize === 'Normal' ? 'lg:text-3xl' : 'lg:text-4xl'}
                `}
                            >
                                {props.title}
                            </h1>
                        )}
                        {props.description && (
                            <h2
                                className={`
                  leading-6 lg:leading-8
                  ${props.colorReverse ? 'text-primary-content' : 'text-neutral'}
                  ${props.fontSize === 'Normal' ? 'lg:text-xl' : 'lg:text-2xl'}
                `}
                            >
                                {props.description}
                            </h2>
                        )}
                    </div>
                )
                : null}
        </>
    )
}

export default Header
